import { useMutation } from "react-query"
import reservationsService from "api/reservationsService"
import { ICreateWebReservation } from "types/reservation"

const useCreateWebReservationMutation = () => {
  return useMutation(async (data: ICreateWebReservation) => {
    const res = await reservationsService.createWebReservation(data)
    return res.data
  })
}

export default useCreateWebReservationMutation
